import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=541247ae&scoped=true"
import script from "./page-footer.vue?vue&type=script&lang=js"
export * from "./page-footer.vue?vue&type=script&lang=js"
import style0 from "./page-footer.vue?vue&type=style&index=0&id=541247ae&prod&lang=css"
import style1 from "./page-footer.vue?vue&type=style&index=1&id=541247ae&prod&scoped=true&lang=less"
import style2 from "@/assets/h5css/zujian/pageFooter.less?vue&type=style&index=2&id=541247ae&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541247ae",
  null
  
)

export default component.exports